export default "__VITE_ASSET__Bk2CNIxh__"